import { Injectable } from '@angular/core';
import { CustomerAccountQueryInput } from 'app/backend/api';

@Injectable()
export class CustomerAccountParams {

    public orderBy: 'name' | 'country' = 'name';
    public searchValue = '';
    public selectedSiteId = '';
    public query: CustomerAccountQueryInput = {
        search: '',
        nedermanId: '',
        orderBy: 'name'
    };
}
